<template>
    <button-base styleType="secondary">
        <slot></slot>
    </button-base>
</template>
